import {
  Avatar,
  Box,
  Flex,
  Heading,
  Icon,
  Text,
} from '@chakra-ui/react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Link, graphql, useStaticQuery } from 'gatsby';

import React from 'react';
import { StarIcon } from '@chakra-ui/icons';
import { generate } from 'shortid';
import BBBSeal from '../../assets/Ab-bbb-seal-a.svg';
import { CardOne, LinkOne } from '../_index';
import GoogleG from '../../assets/Google__G__Logo.svg';
import GoogleLogo from '../../assets/Google_2015_logo.svg';

const ReviewsRotator = ({ data }) => {
  const { googleReviews, googleFiveStarImg } = useStaticQuery(query);
  const image = getImage(googleFiveStarImg);
  const slides = googleReviews.nodes.map((r, i) => (
    <Box
      mr={4}
      mb={4}
      key={generate()}
      flexGrow="0"
      flexShrink="0"
      width={{ base: '90vw', md: '40vw', lg: '30vw' }}
    >
      <CardOne width={{ base: '100%' }}>
        <Box
          mb={3}
          display="flex"
          alignItems="center"
        >
          <Box mr={2}>
            <GoogleG />
          </Box>
          {Array.from({ length: r.rating }, () => 0).map((j) => (
            <Icon
              key={generate()}
              as={StarIcon}
              boxSize={6}
              color="yellow.300"
            />
          ))}
        </Box>

        <Text
          mb={4}
          fontSize="lg"
          as="em"
          noOfLines="6"
        >
          {r.text}
        </Text>

        <Flex alignItems="center">
          <Avatar
            size="md"
            name={`Google profile of ${r.author_name}`}
            src={r.profile_photo_url}
          />
          {' '}
          <Heading
            as="h6"
            variant="sec"
            size="md"
            mb={0}
            ml={2}
          >
            -
            {' '}
            {r.author_name}
          </Heading>
        </Flex>
        <Box mt={4}>
          <LinkOne to={`/reviews/#${r.googlePlacesId}`}>
            Read Full Review
          </LinkOne>
        </Box>
      </CardOne>
    </Box>
  ));

  return (
    <Box className="hor-rotator-wrapper">
      <Flex
        py={10}
        className="hor-rotator"
        flexDirection="row"
        justifyContent="space-between"
        zIndex="1"
      >
        {slides}
        {slides}
      </Flex>
    </Box>
  );
};

export const query = graphql`
  query {
    googleReviews: allGooglePlacesReview {
      nodes {
        author_url
        author_name
        googlePlacesId
        rating
        profile_photo_url
        time
        relative_time_description
        text
        id
      }
    }
    googleFiveStarImg: file(
      relativePath: { eq: "Google-5-Star.png" }
    ) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED)
      }
    }
  }
`;

export default ReviewsRotator;
